import type { ConsignmentSummary, SrfImportParams } from '@/entities/consignments';

/**
 * The `import-srf` endpoint returns the created consignment — same shape as
 * `GET /api/v2/consignments/{id}`.
 */
export type SrfImportResponse = ConsignmentSummary;

export type { SrfImportParams };

/** Accepted SRF file extensions (Excel workbook). Enforced by `FileUpload`. */
export const SRF_ALLOWED_EXTENSIONS = ['.xlsx'];

/** Maximum SRF file size — 20 MB. Enforced by `FileUpload`. */
export const SRF_MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024;
